export interface CTAQueryStateType {
  brandId?: string;
  fitterId?: string;
  fitterName?: string;
  licensePlate?: string;
  businessOrigin?: string;
  fitterSelectionActive?: boolean;
}
